import React from 'react';
import { useNavigate } from 'react-router-dom';
import nuevaa1 from '../img/nuevaa1.png';
import nuevaa2 from '../img/nuevaa2.png';
import nuevoo3 from '../img/nuevoo3.png';
import nuevoo4 from '../img/nuevoo4.png';
import nuevaa4 from '../img/coves1.jpeg';

const CardsSection = () => {
  // Example data for the cards with their corresponding images

    const navegar = useNavigate();
  const smallCards = [
    { 
      title: "Exotic Destinations", 
      description: "Explore unique places",
      image: nuevaa1
    },
    { 
      title: "Urban Adventures", 
      description: "Discover the city",
      image: nuevaa2
    },
    { 
      title: "Living Nature", 
      description: "Connect with the environment",
      image: nuevoo3
    },
    { 
      title: "Cultural Experiences", 
      description: "Embrace traditions",
      image: nuevoo4
    }
  ];
  const manejarNavegacion = () => {
    navegar('/products');
  };

  return (
    <section className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Section Title */}
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4">
          Discover Our Experiences
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Find your next adventure among our selection of unique experiences
        </p>
      </div>

      {/* Small Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {smallCards.map((card, index) => (
          <div 
            key={index}
            className="group relative overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl bg-white hover:-translate-y-1"
          >
            <div className="aspect-w-4 aspect-h-3">
              <img
                src={card.image}
                alt={card.title}
                className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300">
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="text-xl font-bold text-white mb-2">{card.title}</h3>
                <p className="text-gray-200 text-sm">{card.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Featured Card */}
      <div className="relative overflow-hidden rounded-xl shadow-xl bg-white">
        <div className="aspect-w-16 aspect-h-7">
          <img
            src={nuevaa4}
            alt="Featured Experience"
            className="object-cover w-full h-full transition-transform duration-700 hover:scale-105"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent">
          <div className="absolute bottom-8 left-8 max-w-xl">
            <span className="inline-block px-4 py-1 mb-4 text-sm font-semibold text-white bg-blue-600 rounded-full">
              Featured
            </span>
            <h2 className="text-3xl font-bold text-white mb-4">
              Premium Experience
            </h2>
            <p className="text-lg text-gray-200 mb-6">
              Discover our special selection of unique adventures designed for the most discerning
            </p>
            <button 
            onClick={manejarNavegacion}
            className="px-6 py-3 text-sm font-semibold text-white rounded-lg transition-colors duration-300" style={{ backgroundColor: '#697565' }}>
              Explore Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CardsSection;
